import { isSecondaryAccount } from '@/utils/accountType'
// LIVE_MAP_ENABLED is no longer used -- Live Map's availability is now
// determined per-fleet instead of by a single global flag. Left commented
// out rather than removed in case a global kill-switch is needed again
// later.
// import { LIVE_MAP_ENABLED } from '@/config'

const getHomeRoute = () => {
  return {
    path: '/',
    name: 'Home',
    component: () => import('@/layouts/InsightsLayout'),
    redirect: () => {
      if (isSecondaryAccount()) {
        // return LIVE_MAP_ENABLED ? '/live-map' : '/livestream'
        return '/live-map'
      }
      return '/fleet'
    },
    children: [
      {
        path: '/fleet',
        name: 'Fleet Insights',
        component: () => import('@/views/FleetInsights.vue'),
        meta: { requiresPrimaryAccount: true },
      },
      {
        path: '/vehicle',
        name: 'Vehicle Insights',
        component: () => import('@/views/VehicleInsights.vue'),
        meta: { requiresPrimaryAccount: true },
      },
      {
        path: '/livestream',
        name: 'Livestream',
        component: () => import('@/views/Livestream.vue'),
      },
      {
        path: '/live-map',
        name: 'Live Map',
        component: () => import('@/views/LiveMap.vue'),
        // meta: { requiresLiveMapEnabled: true },
      },
      {
        path: '/change-password',
        name: 'Change Password',
        component: () => import('@/views/ChangePassword.vue'),
        meta: { requiresAuth: true },
      },
      {
        path: '/set-timezone',
        name: 'Set Timezone',
        component: () => import('@/views/SetTimezone.vue'),
        meta: { requiresAuth: true },
      },
      {
        path: '/scheduled-reports',
        name: 'Scheduled Reports',
        component: () => import('@/views/ScheduledReports.vue'),
        meta: { requiresAuth: true, requiresPrimaryAccount: true },
      },
    ],
  }
}

export default getHomeRoute
